import { gEnums } from "../../../global/enums/globalEnums";
import { listList } from "../../../global/lists/lists";
import { newPropObject } from "../../../global/viewSettings/helpers/settingsHelpers";
import { propDataOpts, propDefaults } from "../../../global/viewSettings/settingsProps/settingsAll";

const golfPropTypes = Object.freeze({
  handicapSourceType: 'handicapSourceType',
  handicapIndex: 'handicapIndex',
  tournamentHandicapIndex: 'tournamentHandicapIndex',
  phoneNumber: 'phoneNumber',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  name: 'name',
});

export const _golfFormTypes = Object.freeze({
  courseHandicap: 'courseHandicap',
  golfer: 'golfer',
  handicapIndex: 'handicapIndex',
  tournamentHandicapIndex: 'tournamentHandicapIndex',
})

export const golfPropAllows = (propAllows) => {
  const items = {}
  _.forEach(propAllows, (propAllow, paKey) => {
    switch (paKey) {
      case 'matchCubeType':
        items[paKey] = newPropObject(paKey, propDataOpts(false, gEnums.formItemTypes.select, null, { trueList: listList(matchCubeTypes) }))
        break;
      default:
        items[paKey] = newPropObject(paKey, propDataOpts(false, gEnums.formItemTypes.checkbox))
    }
  })
  return items
}

export const golfAppForms = () => {

  // const baseFields = {
  //   handicapSourceType: newPropObject(
  //     golfPropTypes.handicapSourceType,
  //     propDataOpts(true, gEnums.formItemTypes.select, null, { trueList: listList(hcpSourceTypes) })
  //   ),
  //   handicapIndex: newPropObject(
  //     golfPropTypes.handicapIndex,
  //     propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })
  //   ),
  //   tournamentHandicapIndex: newPropObject(
  //     golfPropTypes.tournamentHandicapIndex,
  //     propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })
  //   )
  // };

  return {
    handicapIndex: {
      // ...baseFields,
      handicapSourceType: newPropObject(golfPropTypes.handicapSourceType, propDataOpts(true, gEnums.formItemTypes.select, null, { trueList: listList(hcpSourceTypes) })),
      handicapIndex: newPropObject('handicapIndex', propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })),
      phoneNumber: newPropObject('phoneNumber', propDataOpts(true, gEnums.formItemTypes.phoneNumber)),
      email: newPropObject('email', propDataOpts(true, gEnums.formItemTypes.email)),
    },
    tournamentHandicapIndex: {
      // ...baseFields,
      handicapSourceType: newPropObject('handicapSourceType', propDataOpts(false, gEnums.formItemTypes.textReadOnly)),
      handicapIndex: newPropObject('handicapIndex', propDataOpts(false, gEnums.formItemTypes.textReadOnly)),
      tournamentHandicapIndex: newPropObject('tournamentHandicapIndex', propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })),
      allowLineupModification: newPropObject('allowLineupModification', propDataOpts(false, gEnums.formItemTypes.checkbox)),
    },
    courseHandicap: {
      // ...baseFields,
      handicapIndex: newPropObject('handicapIndex', propDataOpts(false, gEnums.formItemTypes.textReadOnly)),
      handicapSourceType: newPropObject('handicapSourceType', propDataOpts(false, gEnums.formItemTypes.textReadOnly)),
      tournamentHandicapIndex: newPropObject('tournamentHandicapIndex', propDataOpts(true, gEnums.formItemTypes.textReadOnly)),
    },
    golfer: {
      firstName: newPropObject('firstName', propDataOpts(false, gEnums.formItemTypes.text)),
      lastName: newPropObject('lastName', propDataOpts(false, gEnums.formItemTypes.text)),
      email: newPropObject('email', propDataOpts(true, gEnums.formItemTypes.email)),
      phoneNumber: newPropObject('phoneNumber', propDataOpts(false, gEnums.formItemTypes.phoneNumber)),
      handicapIndex: newPropObject('handicapIndex', propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })),
      handicapSourceType: newPropObject('handicapSourceType', propDataOpts(true, gEnums.formItemTypes.select, null, { trueList: listList(hcpSourceTypes) })),
    },
    golfCourseTeeBox: {
      name: newPropObject('name', propDataOpts(false, gEnums.formItemTypes.text)),
    }
  }
}

export const matchCubeTypes = Object.freeze({
  alt: 'alt',
  normal: 'normal',
})

export const hcpSourceTypes = Object.freeze({
  diablo: 'diablo',
  garmin: 'garmin',
  golfPad: 'golfPad',
  grint: 'grint',
  localLeague: 'localLeague',
  simpleHandicap: 'simpleHandicap',
  usga: 'usga',
  usHandicap: 'usHandicap',
})

export const appFormProp = ({
  propKey,
  required = true,
  formItemType,
  defaultValue = null,
  opts = {},
}) => {
  return newPropObject(
    propKey,
    propDataOpts(required, formItemType, defaultValue, opts)
  );
};
